<template>
  <v-text-field
    outlined
    v-bind="$attrs"
    @input="updateFieldValue(name, $event)"
    :value="currentValue"
    :messages="[error]"
    :error="!!error"
  ></v-text-field>
</template>
<script>
import baseInput from './baseInput';

export default {
  mixins: [baseInput],
};
</script>
